window.VH = window.VH === undefined ? {} : window.VH;
VH.BeforeUnload = {
    obu : function obu () {
        return true;
    },
    init : function init() {
        let _t = VH.BeforeUnload;
        VH.Helper.w.on('beforeunload', _t.obu);
        VH.Helper.b.on('submit', 'form', function () {
            VH.Helper.w.off('beforeunload', _t.obu);
        });
    }
};